import {format} from 'date-fns';
import {enCA, frCA} from 'date-fns/locale';

export function FormatPhoneNumber(phoneNumber){
    return phoneNumber.substring(0,1) + ' (' + phoneNumber.substring(1,4) + ') ' +  phoneNumber.substring(4,7) + '-' + phoneNumber.substring(7,11)

}

export function handleInitials(firstName,lastName){
   
    if (firstName!=undefined && lastName!=undefined && firstName.length>0 && lastName.length > 0)
    {
      const initA = firstName.charAt(0).toUpperCase();
      const initB = lastName.charAt(0).toUpperCase();
      return initA.concat(initB);
    }
    else{
      return "NA"
    }
  
}

export function formatDate(date,lang,withTime=false){
  if (date.length==0){
    return ''
  }
  var formatEn="MMM dd, yyyy"
  var formatFr="dd MMM, yyyy"
  
  if (withTime){
    formatEn="MMM dd, yyyy H:mm"
    formatFr="dd MMM, yyyy H:mm"
  }
  
  if(lang==="fr"){
      return format(new Date(date), formatFr, {locale: frCA});
  }
  return format(new Date(date), formatEn, {locale: enCA});
}